module.exports = __webpack_public_path__ + "media/images/front/icon_case-eae99c4744d51028cee73cad7ae2d194.png";